// Helpers shared by the client record screens (list, page, appointment modal).

/** "YYYY-MM-DD" -> "12/10/2026" (es-AR); anything else comes back as is, "—" when empty. */
export const fechaAR = (value) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value || "");
  return m ? `${m[3]}/${m[2]}/${m[1]}` : value || "—";
};

/** Reads `{ message, codigo, status }` out of an axios error, with a fallback message. */
export const errorDeApi = (error, fallback) => ({
  message: error?.response?.data?.message || fallback,
  codigo: error?.response?.data?.codigo || "",
  status: error?.response?.status || 0,
});

/** `info` of a successful response, `null` when the shape is not the contract's. */
export const infoDe = (response) => (response?.data?.isSuccess === true ? response.data.info ?? null : null);

export const MAX_TAGS = 10;
export const MAX_TAG_LENGTH = 30;
export const MAX_NOTE_LENGTH = 2000;

export const KIND_LABEL = { general: "General", technical: "Ficha técnica" };

/** Marketing consent of a record (`{ status, at, source }`): label for the badge and the detail line ("hoy · al reservar"). */
export const CONSENT_FILTROS = [
  { value: "", label: "Todos" },
  { value: "opted_in", label: "Aceptan" },
  { value: "opted_out", label: "No aceptan" },
  { value: "unknown", label: "Sin respuesta" },
];
export const CONSENT_LABEL = { opted_in: "Acepta novedades", opted_out: "No acepta", unknown: "Sin respuesta" };
const CONSENT_ORIGEN = { booking: "al reservar", organizer: "cargado por el local", unsubscribe: "se dio de baja", chat_opt_out: "baja por WhatsApp" };

export const estadoConsent = (c) => (c && CONSENT_LABEL[c.status] ? c.status : "unknown");

/** "12/10/2026 · al reservar", "" when there is neither a date nor a source. */
export const detalleConsent = (c) => {
  if (!c || estadoConsent(c) === "unknown") return "";
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(c.at || "");
  const partes = [m ? `${m[3]}/${m[2]}/${m[1]}` : "", CONSENT_ORIGEN[c.source] || ""].filter(Boolean);
  return partes.join(" · ");
};
